//In case a default value is set, ensure that the Get tickets button is not disabled (Modern tribe sets it to be disabled by default).
let interval;
const maxRetries = 20;
let attempts = 1;

const fireChangeEvent = function () {
    document.querySelectorAll('.tribe-tickets-quantity, .tribe-tickets__tickets-item-quantity-number-input')
        .forEach((el) => {
            el.dispatchEvent(new Event('change', {bubbles: true, cancelable: false}));
        });

    if (document.querySelector('.tribe-tickets__footer--active') || attempts >= maxRetries) {
        clearInterval(interval);
    }

    attempts++;
};

interval = setInterval(fireChangeEvent, 1000);

jQuery(document).ready(function ($) {
  const numberOfProducts = $('.tribe-tickets__tickets-item').length;
  if (numberOfProducts <= 1 ||
    typeof tribe === 'undefined' ||
    typeof tribe.tickets === 'undefined' ||
    typeof tribe.tickets.block === 'undefined' ||
    typeof tribe.tickets.block.stepDown === 'undefined'
  ) {
    return;
  }

  // Multiple products exist against this event.
  // Overwrite the stepDown function to allow a decrease from min straight to 0.
  tribe.tickets.block.stepDown = function ($input, originalValue) {
    const min = $input.attr('min') ? Number($input.attr('min')) : 0;
    const step = $input.attr('step') ? Number($input.attr('step')) : 1;
    const decrease = (min <= originalValue - step && 0 < originalValue - step) ? originalValue - step : 0;

    if ('function' === typeof $input[0].stepDown) {
      try {
        $input[0].stepDown();
        if (originalValue === min) {
          $input[0].value = decrease;
        }
      } catch (ex) {
        $input[0].value = decrease;
      }
    } else {
      $input[0].value = decrease;
    }
  };

});
